import Vue from 'vue'
import Vuex from 'vuex'

import rootState from '../index'

Vue.use(Vuex)

export default {
  namespaced: true,
  rootState,
  state: {
    // years, rates, ratesDate
    selects: null,
    emptySystem: null,
    emptyArticle: null,
    tableOptions: {
      page: 1,
      itemsPerPage: 12,
      sortBy: ['c_nr'],
      sortDesc: [true],
      viewSelected: 0,
      hSelected: 0,
      filter: [''],
      userId: '',
      userRight: 0,
    },
  },
  getters: {
    selects: (state) => state.selects,
    emptySystem: (state) => state.emptySystem,
    emptyArticle: (state) => state.emptyArticle,
    tableOptions: (state) => state.tableOptions,
    // helper
    splitSN: () => (snString) => {
      var result = []

      snString.forEach((item) => {
        // teilen bei Komma
        String(item['sn'])
          .split(',')
          .forEach((sn) => {
            // von - bis
            if (sn.match(/ - /)) {
              // teilen
              var tmp = sn.split(/ - /)
              // SN aufteilen
              var sn1 = tmp[0].trim().match(/([a-z]*)(\d*)([a-z]*)/i)
              var sn2 = tmp[1].trim().match(/([a-z]*)(\d*)([a-z]*)/i)
              // hochzählen
              for (let i = parseInt(sn1[2]); i <= parseInt(sn2[2]); i++) {
                result.push({
                  sn: sn1[1] + i.toString().padStart(sn1[2].length, 0) + sn1[3],
                  no: item['no'],
                })
              }
            } else result.push({ sn: sn.trim(), no: item['no'] })
          })
      })

      return result
    },
  },
  mutations: {
    setSelects(state, values) {
      state.selects = values
    },
    setEmptySystem(state, values) {
      state.emptySystem = values
    },
    setEmptyArticle(state, values) {
      state.emptyArticle = values
    },
    setTableOptions(state, values) {
      state.tableOptions = values
    },
  },
  actions: {
    async loadInitData({ dispatch }) {
      await Promise.all([dispatch('getSelects')])
    },
    getSelects({ commit, getters }) {
      if (getters.selects == null) {
        return Vue.prototype.$axios.get('prm/init').then((res) => {
          commit('setSelects', res.data.selects)
          res.data.emptySystem.article = []
          commit('setEmptySystem', JSON.stringify(res.data.emptySystem))
          commit('setEmptyArticle', JSON.stringify(res.data.emptyArticle))
          return 'init loaded'
        })
      } else return 'init'
    },
  },
  modules: {},
}
